import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { HeadingS } from '../../dls/components/typography/typography';
import CloseIcon from '../../dls/icons/close-icon.svg';
import { useClickOutside } from '../../small-tools/use-click-outside';
import { withAliases } from '../utils/with-aliases';
import { IconButton } from '../../dls/components/icon-button/icon-button';
var ANIMATION_DURATION = 200;
var Actions = function (_a) {
    var children = _a.children;
    return (_jsx("div", { className: styles['actions-container'], children: children }));
};
var Content = function (_a) {
    var children = _a.children;
    return _jsx("div", { className: styles.content, children: children });
};
var Subtitle = function (_a) {
    var children = _a.children;
    return (_jsx("div", { className: styles['subtitle-container'], children: children }));
};
var BaseBottomSheet = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose, children = _a.children, title = _a.title, disabled = _a.disabled, closeOnOutsideClick = _a.closeOnOutsideClick;
    var bottomSheetRef = useRef(null);
    var _d = useState(false), isClosing = _d[0], setIsClosing = _d[1];
    var _e = useState(false), shouldRender = _e[0], setShouldRender = _e[1];
    var handleClose = useCallback(function () {
        setIsClosing(true);
        setTimeout(function () {
            onClose();
        }, ANIMATION_DURATION);
    }, [onClose]);
    var handleClickOutside = useCallback(function () {
        if (closeOnOutsideClick) {
            handleClose();
        }
    }, [closeOnOutsideClick, handleClose]);
    useClickOutside(bottomSheetRef, handleClickOutside, ['data-bottom-sheet']);
    useEffect(function () {
        var timer;
        var scrollY = window.scrollY;
        if (open) {
            setIsClosing(false);
            setShouldRender(true);
            // Lock scroll
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = "-".concat(scrollY, "px");
            document.body.style.overflow = 'hidden';
        }
        else {
            setIsClosing(true);
            timer = setTimeout(function () {
                setShouldRender(false);
            }, ANIMATION_DURATION);
        }
        return function () {
            if (timer) {
                clearTimeout(timer);
            }
            document.body.style.position = 'relative';
            document.body.style.width = 'auto';
            document.body.style.overflow = '';
            document.body.style.top = '';
            if (scrollY) {
                window.scrollTo(0, scrollY);
            }
        };
    }, [open]);
    if (!shouldRender)
        return null;
    var actionsElement = React.Children.toArray(children).find(function (child) { return React.isValidElement(child) && child.type === Actions; });
    var subtitleElement = React.Children.toArray(children).find(function (child) { return React.isValidElement(child) && child.type === Subtitle; });
    // Content is either of Content type or a children excluding other available types
    var contentElement = React.Children.toArray(children).find(function (child) { return React.isValidElement(child) && child.type === Content; }) ||
        React.Children.toArray(children).find(function (child) { return React.isValidElement(child) && child.type !== Actions && child.type !== Subtitle; });
    return ReactDOM.createPortal(_jsxs("div", { className: styles['bottom-sheet-container'], children: [_jsx("div", { className: classNames(styles.backdrop, (_b = {},
                    _b[styles.closing] = isClosing,
                    _b)) }), _jsxs("div", { ref: bottomSheetRef, "data-bottom-sheet": true, className: classNames(styles['bottom-sheet'], (_c = {},
                    _c[styles.closing] = isClosing,
                    _c)), children: [_jsxs("div", { className: styles['header-container'], children: [_jsxs("div", { className: styles['header-title-container'], children: [_jsx(HeadingS, { color: disabled ? 'disabled' : 'primary', children: title }), subtitleElement] }), _jsx(IconButton.L, { Icon: _jsx(CloseIcon, {}), onClick: handleClose, disabled: disabled })] }), contentElement, actionsElement] })] }), document.body);
};
export var BottomSheet = withAliases(BaseBottomSheet, {
    Actions: Actions,
    Content: Content,
    Subtitle: Subtitle,
});
